/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';

class Table extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isOpen: PropTypes.bool,
    };

    state = {
        blank: [['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--'], ['--', '--', '--']],
    };

    render() {
        const { isOpen } = this.props;
        const { tit, data, idx, _idx } = this.props.content;
        const { blank } = this.state;
        const isGreen = item => {
            if (item === '买盘' || item === '卖盘') {
                return item === '卖盘' ? styles.green : '';
            }
            if (item.indexOf('%') !== -1) {
                if (item.slice(0, item.length - 1) * 1 < 0) {
                    return styles.green;
                } else if (item.slice(0, item.length - 1) * 1 === 0) {
                    return styles.black;
                } else {
                    return '';
                }
            }
        };

        return (
            <div className={styles.table}>
                <table border="0">
                    <tbody className={idx === 0 && _idx === 0 ? styles.grey : ''}>
                        <tr>
                            {tit && tit.length > 0 && tit.map && tit.map((item, index) => <th key={index}>{item}</th>)}
                        </tr>
                        {data && data.length > 0 && data.map
                            ? data.map((item, index) => (
                                  <tr key={index} className={isGreen(item[2])}>
                                      {item.map((_item, index) => {
                                          if (index === 0 && _item) {
                                              return (
                                                  <td key={index}>
                                                      {typeof _item === 'string' ? (
                                                          _item
                                                      ) : _item.name ? (
                                                          <a href={_item.url} rel={rel} target="_blank">
                                                              {_item.name}
                                                          </a>
                                                      ) : (
                                                          <span style={{ color: '#273766' }}>--</span>
                                                      )}
                                                  </td>
                                              );
                                          } else {
                                              return (
                                                  <td key={index}>
                                                      {isOpen && _item ? (
                                                          _item
                                                      ) : (
                                                          <span style={{ color: '#273766' }}>--</span>
                                                      )}
                                                  </td>
                                              );
                                          }
                                      })}
                                  </tr>
                              ))
                            : blank.map((item, index) => {
                                  return (
                                      <tr key={index}>
                                          {item.map((_item, index) => {
                                              return (
                                                  <td key={index}>
                                                      <span style={{ color: '#273766' }}>--</span>
                                                  </td>
                                              );
                                          })}
                                      </tr>
                                  );
                              })}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default errorBoundary(Table);
